import { initContract as xe } from "@ts-rest/core";
import De, { z as a } from "zod";
const Ae = "3.0.2", qe = {
  "/dataset/{datasetId}/locations": {
    get: {
      description: "Obtains all the locations for a dataset by the dataset ID, which by passing in the appropriate options, might be in different formats",
      summary: "obtains a dataset's locations",
      tags: [],
      parameters: [
        {
          name: "datasetId",
          in: "path",
          required: !0,
          schema: {
            type: "string",
            pattern: "^[A-Za-z0-9_-]+$"
          },
          description: "uniquely specifies the dataset wanted"
        }
      ],
      operationId: "getDatasetLocations",
      responses: {
        200: {
          description: "200",
          content: {
            "application/json": {
              schema: {
                type: "array",
                items: {
                  type: "array",
                  items: {
                    type: "number"
                  },
                  minItems: 2,
                  maxItems: 2,
                  nullable: !0
                },
                description: "the dataset matching the supplied ID"
              }
            }
          }
        },
        400: {
          description: "400",
          content: {
            "application/json": {
              schema: {
                type: "object",
                properties: {
                  message: {
                    type: "string"
                  }
                },
                required: [
                  "message"
                ],
                additionalProperties: !0,
                description: "no such dataset"
              }
            }
          }
        },
        404: {
          description: "404",
          content: {
            "application/json": {
              schema: {
                type: "object",
                properties: {
                  message: {
                    type: "string"
                  }
                },
                required: [
                  "message"
                ],
                additionalProperties: !0,
                description: "no such dataset"
              }
            }
          }
        }
      }
    }
  },
  "/dataset/{datasetId}/search": {
    get: {
      description: "Obtains an array of dataset item indexes, which match the search criteria supplied",
      summary: "obtains a list of dataset entries satisfying the search criteria supplied",
      tags: [],
      parameters: [
        {
          name: "datasetId",
          in: "path",
          required: !0,
          schema: {
            type: "string",
            pattern: "^[A-Za-z0-9_-]+$"
          },
          description: "uniquely specifies the dataset wanted"
        },
        {
          name: "text",
          in: "query",
          description: "a text fragment to match",
          schema: {
            type: "string"
          }
        },
        {
          name: "filter",
          in: "query",
          description: "uniquely specifies the taxonomy filter items wanted",
          schema: {
            oneOf: [
              {
                type: "array",
                items: {
                  type: "string"
                }
              },
              {
                type: "string"
              }
            ]
          }
        },
        {
          name: "returnProps",
          in: "query",
          description: "The props to return as an array of item objects. If not specified, only an flattened array of indexes is returned.",
          schema: {
            type: "array",
            items: {
              type: "string"
            }
          }
        },
        {
          name: "page",
          in: "query",
          description: "The page number to return. If not specified, all items are returned.",
          schema: {
            type: "integer",
            minimum: 0,
            nullable: !0
          }
        },
        {
          name: "pageSize",
          in: "query",
          description: "The number of items per page. If not specified, all items are returned.",
          schema: {
            type: "integer",
            minimum: 0,
            exclusiveMinimum: 0
          }
        }
      ],
      operationId: "searchDataset",
      responses: {
        200: {
          description: "200",
          content: {
            "application/json": {
              schema: {
                oneOf: [
                  {
                    type: "array",
                    items: {
                      type: "integer",
                      minimum: 0
                    }
                  },
                  {
                    type: "array",
                    items: {
                      allOf: [
                        {
                          type: "object",
                          additionalProperties: {
                            nullable: !0
                          }
                        },
                        {
                          type: "object",
                          properties: {
                            index: {
                              type: "integer",
                              minimum: 0
                            }
                          },
                          required: [
                            "index"
                          ]
                        }
                      ]
                    }
                  }
                ],
                description: "the dataset item indexes matching the supplied criteria"
              }
            }
          }
        },
        400: {
          description: "400",
          content: {
            "application/json": {
              schema: {
                type: "object",
                properties: {
                  message: {
                    type: "string"
                  }
                },
                required: [
                  "message"
                ],
                additionalProperties: !0,
                description: "no such dataset"
              }
            }
          }
        },
        404: {
          description: "404",
          content: {
            "application/json": {
              schema: {
                type: "object",
                properties: {
                  message: {
                    type: "string"
                  }
                },
                required: [
                  "message"
                ],
                additionalProperties: !0,
                description: "no such dataset"
              }
            }
          }
        }
      }
    }
  },
  "/dataset/{datasetId}/item/{datasetItemIdOrIx}": {
    get: {
      description: "Obtains a single dataset item by its ID or its index, and the dataset's ID.",
      summary: "obtains a dataset item by its unique ID",
      tags: [],
      parameters: [
        {
          name: "datasetId",
          in: "path",
          required: !0,
          schema: {
            type: "string",
            pattern: "^[A-Za-z0-9_-]+$"
          },
          description: "uniquely specifies the dataset wanted"
        },
        {
          name: "datasetItemIdOrIx",
          in: "path",
          required: !0,
          schema: {
            type: "string"
          },
          description: "Uniquely specifies the dataset item wanted within the dataset. This param must be base64 encoded. The decoded param should start with an @ to indicate an index, otherwise it is assumed to be an id"
        },
        {
          name: "returnProps",
          in: "query",
          description: "The props to return. If not specified, all props are returned. Note that the item's ID and index are always returned.",
          schema: {
            type: "array",
            items: {
              type: "string"
            }
          }
        }
      ],
      operationId: "getDatasetItem",
      responses: {
        200: {
          description: "200",
          content: {
            "application/json": {
              schema: {
                allOf: [
                  {
                    allOf: [
                      {
                        type: "object",
                        properties: {
                          id: {
                            type: "string"
                          }
                        },
                        required: [
                          "id"
                        ]
                      },
                      {
                        type: "object",
                        additionalProperties: {
                          nullable: !0
                        }
                      }
                    ]
                  },
                  {
                    type: "object",
                    properties: {
                      index: {
                        type: "integer",
                        minimum: 0
                      }
                    },
                    required: [
                      "index"
                    ]
                  }
                ],
                description: "the dataset item matching the supplied ID or index"
              }
            }
          }
        },
        400: {
          description: "400",
          content: {
            "application/json": {
              schema: {
                type: "object",
                properties: {
                  message: {
                    type: "string"
                  }
                },
                required: [
                  "message"
                ],
                additionalProperties: !0,
                description: "no such dataset"
              }
            }
          }
        },
        404: {
          description: "404",
          content: {
            "application/json": {
              schema: {
                type: "object",
                properties: {
                  message: {
                    type: "string"
                  }
                },
                required: [
                  "message"
                ],
                additionalProperties: !0,
                description: "no such dataset"
              }
            }
          }
        }
      }
    }
  },
  "/dataset/{datasetId}/totals": {
    get: {
      description: "Gets the total number of results under each item in the directory.",
      summary: "get the total number of results under each item in the directory",
      tags: [],
      parameters: [
        {
          name: "datasetId",
          in: "path",
          required: !0,
          schema: {
            type: "string",
            pattern: "^[A-Za-z0-9_-]+$"
          },
          description: "uniquely specifies the dataset wanted"
        }
      ],
      operationId: "getTotals",
      responses: {
        200: {
          description: "200",
          content: {
            "application/json": {
              schema: {
                type: "object",
                additionalProperties: {
                  type: "number"
                },
                description: "the total result numbers for a map"
              }
            }
          }
        },
        400: {
          description: "400",
          content: {
            "application/json": {
              schema: {
                type: "object",
                properties: {
                  message: {
                    type: "string"
                  }
                },
                required: [
                  "message"
                ],
                additionalProperties: !0,
                description: "no such dataset"
              }
            }
          }
        },
        404: {
          description: "404",
          content: {
            "application/json": {
              schema: {
                type: "object",
                properties: {
                  message: {
                    type: "string"
                  }
                },
                required: [
                  "message"
                ],
                additionalProperties: !0,
                description: "no such dataset"
              }
            }
          }
        }
      }
    }
  },
  "/dataset/{datasetId}/config": {
    get: {
      description: "Obtains configured parameters for a datset, which amongst other things, include default values for various options, and definitions of vocabulary terms with their localised labels, that are used to interpret identifers in the data and/or elsewhere.",
      summary: "obtain various configured parameters for a dataset",
      tags: [],
      parameters: [
        {
          name: "datasetId",
          in: "path",
          required: !0,
          schema: {
            type: "string",
            pattern: "^[A-Za-z0-9_-]+$"
          },
          description: "uniquely specifies the dataset wanted"
        }
      ],
      operationId: "getConfig",
      responses: {
        200: {
          description: "200",
          content: {
            "application/json": {
              schema: {
                type: "object",
                properties: {
                  prefixes: {
                    type: "object",
                    additionalProperties: {
                      type: "string"
                    }
                  },
                  vocabs: {
                    type: "object",
                    additionalProperties: {
                      type: "object",
                      additionalProperties: {
                        type: "object",
                        properties: {
                          title: {
                            type: "string"
                          },
                          terms: {
                            type: "object",
                            additionalProperties: {
                              type: "string"
                            }
                          }
                        },
                        required: [
                          "title",
                          "terms"
                        ]
                      }
                    }
                  },
                  itemProps: {
                    allOf: [
                      {
                        type: "object",
                        properties: {
                          id: {
                            type: "object",
                            properties: {
                              from: {
                                type: "string"
                              },
                              titleUri: {
                                type: "string"
                              },
                              filter: {
                                type: "boolean",
                                enum: [
                                  !1
                                ]
                              },
                              search: {
                                type: "boolean"
                              },
                              type: {
                                type: "string",
                                enum: [
                                  "value"
                                ]
                              },
                              as: {
                                type: "string",
                                enum: [
                                  "string",
                                  "boolean",
                                  "number"
                                ]
                              },
                              strict: {
                                type: "boolean"
                              },
                              nullable: {
                                type: "boolean"
                              }
                            },
                            required: [
                              "type"
                            ]
                          }
                        },
                        required: [
                          "id"
                        ]
                      },
                      {
                        type: "object",
                        additionalProperties: {
                          discriminator: {
                            propertyName: "type"
                          },
                          oneOf: [
                            {
                              type: "object",
                              properties: {
                                from: {
                                  type: "string"
                                },
                                titleUri: {
                                  type: "string"
                                },
                                filter: {
                                  oneOf: [
                                    {
                                      type: "object",
                                      properties: {
                                        preset: {
                                          type: "boolean",
                                          enum: [
                                            !0
                                          ]
                                        },
                                        to: {
                                          nullable: !0
                                        }
                                      },
                                      required: [
                                        "preset"
                                      ]
                                    },
                                    {
                                      type: "boolean"
                                    }
                                  ]
                                },
                                search: {
                                  type: "boolean"
                                },
                                type: {
                                  type: "string",
                                  enum: [
                                    "value"
                                  ]
                                },
                                as: {
                                  type: "string",
                                  enum: [
                                    "string",
                                    "boolean",
                                    "number"
                                  ]
                                },
                                strict: {
                                  type: "boolean"
                                },
                                nullable: {
                                  type: "boolean"
                                }
                              },
                              required: [
                                "type"
                              ]
                            },
                            {
                              type: "object",
                              properties: {
                                from: {
                                  type: "string"
                                },
                                titleUri: {
                                  type: "string"
                                },
                                filter: {
                                  oneOf: [
                                    {
                                      type: "object",
                                      properties: {
                                        preset: {
                                          type: "boolean",
                                          enum: [
                                            !0
                                          ]
                                        },
                                        to: {
                                          nullable: !0
                                        }
                                      },
                                      required: [
                                        "preset"
                                      ]
                                    },
                                    {
                                      type: "boolean"
                                    }
                                  ]
                                },
                                search: {
                                  type: "boolean"
                                },
                                type: {
                                  type: "string",
                                  enum: [
                                    "vocab"
                                  ]
                                },
                                uri: {
                                  type: "string"
                                },
                                sorted: {
                                  oneOf: [
                                    {
                                      type: "boolean"
                                    },
                                    {
                                      type: "string",
                                      enum: [
                                        "asc"
                                      ]
                                    },
                                    {
                                      type: "string",
                                      enum: [
                                        "desc"
                                      ]
                                    }
                                  ]
                                }
                              },
                              required: [
                                "type",
                                "uri"
                              ]
                            },
                            {
                              type: "object",
                              properties: {
                                from: {
                                  type: "string"
                                },
                                titleUri: {
                                  type: "string"
                                },
                                filter: {
                                  oneOf: [
                                    {
                                      type: "object",
                                      properties: {
                                        preset: {
                                          type: "boolean",
                                          enum: [
                                            !0
                                          ]
                                        },
                                        to: {
                                          nullable: !0
                                        }
                                      },
                                      required: [
                                        "preset"
                                      ]
                                    },
                                    {
                                      type: "boolean"
                                    }
                                  ]
                                },
                                search: {
                                  type: "boolean"
                                },
                                type: {
                                  type: "string",
                                  enum: [
                                    "multi"
                                  ]
                                },
                                of: {
                                  oneOf: [
                                    {
                                      type: "object",
                                      properties: {
                                        type: {
                                          type: "string",
                                          enum: [
                                            "value"
                                          ]
                                        },
                                        as: {
                                          type: "string",
                                          enum: [
                                            "string",
                                            "boolean",
                                            "number"
                                          ]
                                        },
                                        strict: {
                                          type: "boolean"
                                        },
                                        nullable: {
                                          type: "boolean"
                                        }
                                      },
                                      required: [
                                        "type"
                                      ]
                                    },
                                    {
                                      type: "object",
                                      properties: {
                                        type: {
                                          type: "string",
                                          enum: [
                                            "vocab"
                                          ]
                                        },
                                        uri: {
                                          type: "string"
                                        },
                                        sorted: {
                                          oneOf: [
                                            {
                                              type: "boolean"
                                            },
                                            {
                                              type: "string",
                                              enum: [
                                                "asc"
                                              ]
                                            },
                                            {
                                              type: "string",
                                              enum: [
                                                "desc"
                                              ]
                                            }
                                          ]
                                        }
                                      },
                                      required: [
                                        "type",
                                        "uri"
                                      ]
                                    }
                                  ]
                                }
                              },
                              required: [
                                "type",
                                "of"
                              ]
                            }
                          ]
                        }
                      }
                    ]
                  },
                  languages: {
                    type: "array",
                    items: {
                      type: "string",
                      enum: [
                        "aa",
                        "ab",
                        "ae",
                        "af",
                        "ak",
                        "am",
                        "an",
                        "ar",
                        "as",
                        "av",
                        "ay",
                        "az",
                        "ba",
                        "be",
                        "bg",
                        "bi",
                        "bm",
                        "bn",
                        "bo",
                        "br",
                        "bs",
                        "ca",
                        "ce",
                        "ch",
                        "co",
                        "cr",
                        "cs",
                        "cu",
                        "cv",
                        "cy",
                        "da",
                        "de",
                        "dv",
                        "dz",
                        "ee",
                        "el",
                        "en",
                        "eo",
                        "es",
                        "et",
                        "eu",
                        "fa",
                        "ff",
                        "fi",
                        "fj",
                        "fo",
                        "fr",
                        "fy",
                        "ga",
                        "gd",
                        "gl",
                        "gn",
                        "gu",
                        "gv",
                        "ha",
                        "he",
                        "hi",
                        "ho",
                        "hr",
                        "ht",
                        "hu",
                        "hy",
                        "hz",
                        "ia",
                        "id",
                        "ie",
                        "ig",
                        "ii",
                        "ik",
                        "io",
                        "is",
                        "it",
                        "iu",
                        "ja",
                        "jv",
                        "ka",
                        "kg",
                        "ki",
                        "kj",
                        "kk",
                        "kl",
                        "km",
                        "kn",
                        "ko",
                        "kr",
                        "ks",
                        "ku",
                        "kv",
                        "kw",
                        "ky",
                        "la",
                        "lb",
                        "lg",
                        "li",
                        "ln",
                        "lo",
                        "lt",
                        "lu",
                        "lv",
                        "mg",
                        "mh",
                        "mi",
                        "mk",
                        "ml",
                        "mn",
                        "mr",
                        "ms",
                        "mt",
                        "my",
                        "na",
                        "nb",
                        "nd",
                        "ne",
                        "ng",
                        "nl",
                        "nn",
                        "no",
                        "nr",
                        "nv",
                        "ny",
                        "oc",
                        "oj",
                        "om",
                        "or",
                        "os",
                        "pa",
                        "pi",
                        "pl",
                        "ps",
                        "pt",
                        "qu",
                        "rm",
                        "rn",
                        "ro",
                        "ru",
                        "rw",
                        "sa",
                        "sc",
                        "sd",
                        "se",
                        "sg",
                        "si",
                        "sk",
                        "sl",
                        "sm",
                        "sn",
                        "so",
                        "sq",
                        "sr",
                        "ss",
                        "st",
                        "su",
                        "sv",
                        "sw",
                        "ta",
                        "te",
                        "tg",
                        "th",
                        "ti",
                        "tk",
                        "tl",
                        "tn",
                        "to",
                        "tr",
                        "ts",
                        "tt",
                        "tw",
                        "ty",
                        "ug",
                        "uk",
                        "ur",
                        "uz",
                        "ve",
                        "vi",
                        "vo",
                        "wa",
                        "wo",
                        "xh",
                        "yi",
                        "yo",
                        "za",
                        "zh",
                        "zu"
                      ]
                    },
                    minItems: 1
                  },
                  ui: {
                    type: "object",
                    properties: {
                      directory_panel_field: {
                        type: "string"
                      },
                      title: {
                        type: "string"
                      },
                      dataLastUpdated: {
                        type: "string",
                        format: "date-time"
                      },
                      show_map_key: {
                        type: "boolean"
                      },
                      customMarkers: {
                        type: "object",
                        properties: {
                          marker_property_name: {
                            type: "string"
                          },
                          markerIcons: {
                            type: "array",
                            items: {
                              type: "string"
                            }
                          },
                          termsToIconIndex: {
                            allOf: [
                              {
                                type: "object",
                                properties: {
                                  default: {
                                    type: "number"
                                  }
                                },
                                required: [
                                  "default"
                                ]
                              },
                              {
                                type: "object",
                                additionalProperties: {
                                  type: "number"
                                }
                              }
                            ]
                          }
                        },
                        required: [
                          "marker_property_name",
                          "markerIcons",
                          "termsToIconIndex"
                        ]
                      },
                      map: {
                        type: "object",
                        properties: {
                          mapBounds: {}
                        }
                      },
                      logo: {
                        type: "object",
                        properties: {
                          largeLogo: {
                            type: "string"
                          },
                          smallLogo: {
                            type: "string"
                          },
                          altText: {
                            type: "string"
                          },
                          smallScreenPosition: {
                            type: "object",
                            properties: {
                              top: {
                                type: "string"
                              },
                              left: {
                                type: "string"
                              }
                            }
                          },
                          largeScreenPosition: {
                            type: "object",
                            properties: {
                              bottom: {
                                type: "string"
                              },
                              right: {
                                type: "string"
                              }
                            }
                          }
                        }
                      }
                    },
                    required: [
                      "directory_panel_field"
                    ]
                  },
                  popup: {
                    type: "object",
                    properties: {
                      titleProp: {
                        type: "string"
                      },
                      leftPaneWidth: {
                        default: "70%",
                        type: "string"
                      },
                      leftPane: {
                        type: "array",
                        items: {
                          type: "object",
                          properties: {
                            itemProp: {
                              type: "string"
                            },
                            valueStyle: {
                              default: "text",
                              type: "string",
                              enum: [
                                "text",
                                "address",
                                "hyperlink"
                              ]
                            },
                            showBullets: {
                              default: !1,
                              type: "boolean"
                            },
                            singleColumnLimit: {
                              type: "number"
                            },
                            showLabel: {
                              default: !1,
                              type: "boolean"
                            },
                            hyperlinkBaseUri: {
                              default: "",
                              type: "string"
                            },
                            displayText: {
                              type: "string"
                            },
                            analyticOnClick: {
                              default: !1,
                              type: "boolean"
                            }
                          },
                          required: [
                            "itemProp"
                          ]
                        }
                      },
                      topRightPane: {
                        type: "array",
                        items: {
                          type: "object",
                          properties: {
                            itemProp: {
                              type: "string"
                            },
                            valueStyle: {
                              default: "text",
                              type: "string",
                              enum: [
                                "text",
                                "address",
                                "hyperlink"
                              ]
                            },
                            showBullets: {
                              default: !1,
                              type: "boolean"
                            },
                            singleColumnLimit: {
                              type: "number"
                            },
                            showLabel: {
                              default: !1,
                              type: "boolean"
                            },
                            hyperlinkBaseUri: {
                              default: "",
                              type: "string"
                            },
                            displayText: {
                              type: "string"
                            },
                            analyticOnClick: {
                              default: !1,
                              type: "boolean"
                            }
                          },
                          required: [
                            "itemProp"
                          ]
                        }
                      },
                      bottomRightPane: {
                        type: "array",
                        items: {
                          type: "object",
                          properties: {
                            itemProp: {
                              type: "string"
                            },
                            valueStyle: {
                              default: "text",
                              type: "string",
                              enum: [
                                "text",
                                "address",
                                "hyperlink"
                              ]
                            },
                            showBullets: {
                              default: !1,
                              type: "boolean"
                            },
                            singleColumnLimit: {
                              type: "number"
                            },
                            showLabel: {
                              default: !1,
                              type: "boolean"
                            },
                            hyperlinkBaseUri: {
                              default: "",
                              type: "string"
                            },
                            displayText: {
                              type: "string"
                            },
                            analyticOnClick: {
                              default: !1,
                              type: "boolean"
                            }
                          },
                          required: [
                            "itemProp"
                          ]
                        }
                      }
                    },
                    required: [
                      "titleProp",
                      "leftPane",
                      "topRightPane",
                      "bottomRightPane"
                    ]
                  }
                },
                required: [
                  "prefixes",
                  "vocabs",
                  "itemProps",
                  "languages",
                  "ui",
                  "popup"
                ],
                description: "various configured parameters for a map"
              }
            }
          }
        },
        400: {
          description: "400",
          content: {
            "application/json": {
              schema: {
                type: "object",
                properties: {
                  message: {
                    type: "string"
                  }
                },
                required: [
                  "message"
                ],
                additionalProperties: !0,
                description: "no such dataset"
              }
            }
          }
        },
        404: {
          description: "404",
          content: {
            "application/json": {
              schema: {
                type: "object",
                properties: {
                  message: {
                    type: "string"
                  }
                },
                required: [
                  "message"
                ],
                additionalProperties: !0,
                description: "no such dataset"
              }
            }
          }
        }
      }
    }
  },
  "/dataset/{datasetId}/about": {
    get: {
      description: "Obtains information about the datset, in markdown format so it can be easily rendered on a front-end application.",
      summary: "obtain the About text for a dataset",
      tags: [],
      parameters: [
        {
          name: "datasetId",
          in: "path",
          required: !0,
          schema: {
            type: "string",
            pattern: "^[A-Za-z0-9_-]+$"
          },
          description: "uniquely specifies the dataset wanted"
        }
      ],
      operationId: "getAbout",
      responses: {
        200: {
          description: "200",
          content: {
            "application/json": {
              schema: {
                type: "string",
                description: "About text in markdown format"
              }
            }
          }
        },
        400: {
          description: "400",
          content: {
            "application/json": {
              schema: {
                type: "object",
                properties: {
                  message: {
                    type: "string"
                  }
                },
                required: [
                  "message"
                ],
                additionalProperties: !0,
                description: "no such dataset"
              }
            }
          }
        },
        404: {
          description: "404",
          content: {
            "application/json": {
              schema: {
                type: "object",
                properties: {
                  message: {
                    type: "string"
                  }
                },
                required: [
                  "message"
                ],
                additionalProperties: !0,
                description: "no such dataset"
              }
            }
          }
        }
      }
    }
  },
  "/version": {
    get: {
      description: "Obtains version information about the backend Mykomap server, in the form of a JSON object",
      summary: "obtains Mykomap server version information",
      tags: [],
      parameters: [],
      operationId: "getVersion",
      responses: {
        200: {
          description: "200",
          content: {
            "application/json": {
              schema: {
                type: "object",
                properties: {
                  name: {
                    type: "string"
                  },
                  buildTime: {
                    type: "string",
                    format: "date-time"
                  },
                  version: {},
                  commitDesc: {
                    type: "string"
                  },
                  nodeEnv: {
                    type: "string"
                  }
                },
                required: [
                  "name",
                  "buildTime",
                  "version",
                  "commitDesc",
                  "nodeEnv"
                ],
                description: "information about the current Mykomap server build"
              }
            }
          }
        }
      }
    }
  },
  "/datasets": {
    get: {
      description: "Returns an array of the datasets available on this server, each entry carrying the dataset ID and a human-readable label (taken from config.ui.logo.altText, falling back to the ID).",
      summary: "lists the datasets available on this server",
      tags: [],
      parameters: [],
      operationId: "listDatasets",
      responses: {
        200: {
          description: "200",
          content: {
            "application/json": {
              schema: {
                type: "array",
                items: {
                  type: "object",
                  properties: {
                    id: {
                      type: "string",
                      pattern: "^[A-Za-z0-9_-]+$",
                      description: "uniquely specifies the dataset wanted"
                    },
                    label: {
                      type: "string"
                    }
                  },
                  required: [
                    "id",
                    "label"
                  ]
                },
                description: "the list of available datasets"
              }
            }
          }
        }
      }
    }
  }
}, Ne = {
  title: "Mykomap basic data and search API",
  description: "This is a basic API for Mykomap application clients",
  contact: {
    email: "hello@digitalcommons.coop"
  },
  license: {
    name: "Apache 2.0",
    url: "http://www.apache.org/licenses/LICENSE-2.0.html"
  },
  version: "0.1.0"
}, xt = {
  openapi: Ae,
  paths: qe,
  info: Ne
}, h = /* @__PURE__ */ (() => {
  const e = (o) => o instanceof RegExp ? o.source : o, t = (o, ...l) => {
    switch (l.length) {
      case 0:
        return "";
      case 1:
        return `(?:${e(l[0])})`;
      default:
        return "(?:" + l.map((b) => `(?:${e(b)})`).join(o) + ")";
    }
  };
  return { conc: (...o) => new RegExp(o.map((l) => e(l)).join("")), maybe: (...o) => {
    const l = t("|", ...o);
    return new RegExp(`${l}?`);
  }, min: (o, ...l) => {
    const b = t("|", ...l);
    switch (o) {
      case 0:
        return new RegExp(`${b}*`);
      case 1:
        return new RegExp(`${b}+`);
    }
  }, seq: (...o) => new RegExp(t("", ...o)), oneOf: (...o) => new RegExp(t("|", ...o)), uaon: (o) => {
    let [l, b] = o instanceof RegExp ? [o.source, o.flags] : [o, ""];
    return l = l.replace(/^\^?/ms, "^"), l = l.replace(/\$?$/ms, "$"), b = [...new Set((b + "msu").split(""))].join(""), new RegExp(l, b);
  }, wrap: (o, ...l) => new RegExp(t(o, ...l)) };
})();
var O = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {}, X = {}, v = {}, U = {};
Object.defineProperty(U, "__esModule", { value: !0 });
const V = (e) => {
  if (typeof e == "object" && e !== null) {
    if (typeof Object.getPrototypeOf == "function") {
      const t = Object.getPrototypeOf(e);
      return t === Object.prototype || t === null;
    }
    return Object.prototype.toString.call(e) === "[object Object]";
  }
  return !1;
}, y = (...e) => e.reduce((t, n) => {
  if (Array.isArray(n))
    throw new TypeError("Arguments provided to ts-deepmerge must be objects, not arrays.");
  return Object.keys(n).forEach((i) => {
    ["__proto__", "constructor", "prototype"].includes(i) || (Array.isArray(t[i]) && Array.isArray(n[i]) ? t[i] = y.options.mergeArrays ? y.options.uniqueArrayItems ? Array.from(new Set(t[i].concat(n[i]))) : [...t[i], ...n[i]] : n[i] : V(t[i]) && V(n[i]) ? t[i] = y(t[i], n[i]) : t[i] = n[i] === void 0 ? y.options.allowUndefinedOverrides ? n[i] : t[i] : n[i]);
  }), t;
}, {}), E = {
  allowUndefinedOverrides: !0,
  mergeArrays: !0,
  uniqueArrayItems: !0
};
y.options = E;
y.withOptions = (e, ...t) => {
  y.options = Object.assign(Object.assign({}, E), e);
  const n = y(...t);
  return y.options = E, n;
};
U.default = y;
Object.defineProperty(v, "__esModule", { value: !0 });
v.generateSchema = v.extendApi = void 0;
const p = U, x = De;
function Se(e, t = {}) {
  return e.metaOpenApi = Object.assign(e.metaOpenApi || {}, t), e;
}
v.extendApi = Se;
function Te({ zodRef: e, useOutput: t }) {
  return Object.keys(e.shape).reduce((n, i) => Object.assign(Object.assign({}, n), { [i]: u(e.shape[i], t) }), {});
}
function F({ zodRef: e, schemas: t, useOutput: n }) {
  const i = u(e._def.schema, n);
  let r = "undefined";
  if (n && e._def.effect) {
    const s = e._def.effect.type === "transform" ? e._def.effect : null;
    if (s && "transform" in s)
      try {
        r = typeof s.transform(
          ["integer", "number"].includes(`${i.type}`) ? 0 : i.type === "string" ? "" : i.type === "boolean" ? !1 : i.type === "object" ? {} : i.type === "null" ? null : i.type === "array" ? [] : void 0,
          { addIssue: () => {
          }, path: [] }
          // TODO: Discover if context is necessary here
        );
      } catch {
      }
  }
  return (0, p.default)(Object.assign(Object.assign(Object.assign({}, e.description ? { description: e.description } : {}), i), ["number", "string", "boolean", "null"].includes(r) ? {
    type: r
  } : {}), ...t);
}
function Ze({ zodRef: e, schemas: t }) {
  const n = {
    type: "string"
  }, { checks: i = [] } = e._def;
  return i.forEach((r) => {
    switch (r.kind) {
      case "email":
        n.format = "email";
        break;
      case "uuid":
        n.format = "uuid";
        break;
      case "cuid":
        n.format = "cuid";
        break;
      case "url":
        n.format = "uri";
        break;
      case "datetime":
        n.format = "date-time";
        break;
      case "length":
        n.minLength = r.value, n.maxLength = r.value;
        break;
      case "max":
        n.maxLength = r.value;
        break;
      case "min":
        n.minLength = r.value;
        break;
      case "regex":
        n.pattern = r.regex.source;
        break;
    }
  }), (0, p.default)(n, e.description ? { description: e.description } : {}, ...t);
}
function Ee({ zodRef: e, schemas: t }) {
  const n = {
    type: "number"
  }, { checks: i = [] } = e._def;
  return i.forEach((r) => {
    switch (r.kind) {
      case "max":
        n.maximum = r.value, r.inclusive || (n.exclusiveMaximum = r.value);
        break;
      case "min":
        n.minimum = r.value, r.inclusive || (n.exclusiveMinimum = r.value);
        break;
      case "int":
        n.type = "integer";
        break;
      case "multipleOf":
        n.multipleOf = r.value;
    }
  }), (0, p.default)(n, e.description ? { description: e.description } : {}, ...t);
}
function Le({ zodRef: e, schemas: t, useOutput: n }) {
  var i;
  let r;
  e._def.catchall instanceof x.z.ZodNever || ((i = e._def.catchall) === null || i === void 0 ? void 0 : i._def.typeName) === "ZodNever" ? e._def.unknownKeys === "passthrough" ? r = !0 : e._def.unknownKeys === "strict" && (r = !1) : r = u(e._def.catchall, n), r = r != null ? { additionalProperties: r } : {};
  const s = Object.keys(e.shape).filter((m) => {
    const I = e.shape[m];
    return !(I.isOptional() || I instanceof x.z.ZodDefault || I._def.typeName === "ZodDefault") && !(I instanceof x.z.ZodNever || I._def.typeName === "ZodDefault");
  }), c = s.length > 0 ? { required: s } : {};
  return (0, p.default)(Object.assign(Object.assign({ type: "object", properties: Te({
    zodRef: e,
    useOutput: n
  }) }, c), r), e.description ? { description: e.description } : {}, ...t);
}
function Ue({ zodRef: e, schemas: t, useOutput: n }) {
  return (0, p.default)({
    type: "object",
    additionalProperties: e._def.valueType instanceof x.z.ZodUnknown ? {} : u(e._def.valueType, n)
  }, e.description ? { description: e.description } : {}, ...t);
}
function Me({ zodRef: e, schemas: t }) {
  return (0, p.default)({ type: "integer", format: "int64" }, e.description ? { description: e.description } : {}, ...t);
}
function Ce({ zodRef: e, schemas: t }) {
  return (0, p.default)({ type: "boolean" }, e.description ? { description: e.description } : {}, ...t);
}
function Be({ zodRef: e, schemas: t }) {
  return (0, p.default)({ type: "string", format: "date-time" }, e.description ? { description: e.description } : {}, ...t);
}
function $e({ zodRef: e, schemas: t }) {
  return (0, p.default)({
    type: "string",
    format: "null",
    nullable: !0
  }, e.description ? { description: e.description } : {}, ...t);
}
function G({ schemas: e, zodRef: t, useOutput: n }) {
  return (0, p.default)(u(t.unwrap(), n), t.description ? { description: t.description } : {}, ...e);
}
function Ve({ schemas: e, zodRef: t, useOutput: n }) {
  return (0, p.default)(Object.assign({ default: t._def.defaultValue() }, u(t._def.innerType, n)), t.description ? { description: t.description } : {}, ...e);
}
function Fe({ schemas: e, zodRef: t, useOutput: n }) {
  const i = {};
  return t._def.exactLength != null && (i.minItems = t._def.exactLength.value, i.maxItems = t._def.exactLength.value), t._def.minLength != null && (i.minItems = t._def.minLength.value), t._def.maxLength != null && (i.maxItems = t._def.maxLength.value), (0, p.default)(Object.assign({ type: "array", items: u(t.element, n) }, i), t.description ? { description: t.description } : {}, ...e);
}
function Ge({ schemas: e, zodRef: t }) {
  return (0, p.default)({
    type: typeof t._def.value,
    enum: [t._def.value]
  }, t.description ? { description: t.description } : {}, ...e);
}
function K({ schemas: e, zodRef: t }) {
  return (0, p.default)({
    type: typeof Object.values(t._def.values)[0],
    enum: Object.values(t._def.values)
  }, t.description ? { description: t.description } : {}, ...e);
}
function Ke({ schemas: e, zodRef: t, useOutput: n }) {
  return (0, p.default)({
    allOf: [
      u(t._def.left, n),
      u(t._def.right, n)
    ]
  }, t.description ? { description: t.description } : {}, ...e);
}
function We({ schemas: e, zodRef: t, useOutput: n }) {
  const i = t._def.options;
  if (i.reduce((r, s) => r && s._def.typeName === "ZodLiteral", !0)) {
    const r = i, s = r.reduce((c, m) => !c || c === typeof m._def.value ? typeof m._def.value : null, null);
    if (s)
      return (0, p.default)({
        type: s,
        enum: r.map((c) => c._def.value)
      }, t.description ? { description: t.description } : {}, ...e);
  }
  return (0, p.default)({
    oneOf: i.map((r) => u(r, n))
  }, t.description ? { description: t.description } : {}, ...e);
}
function He({ schemas: e, zodRef: t, useOutput: n }) {
  return (0, p.default)({
    discriminator: {
      propertyName: t._def.discriminator
    },
    oneOf: Array.from(t._def.options.values()).map((i) => u(i, n))
  }, t.description ? { description: t.description } : {}, ...e);
}
function Qe({ zodRef: e, schemas: t }) {
  return (0, p.default)({ readOnly: !0 }, e.description ? { description: e.description } : {}, ...t);
}
function Je({ schemas: e, zodRef: t }) {
  return (0, p.default)(u(t._def.type), ...e);
}
function f({ zodRef: e, schemas: t }) {
  return (0, p.default)(e.description ? { description: e.description } : {}, ...t);
}
const W = {
  ZodObject: Le,
  ZodRecord: Ue,
  ZodString: Ze,
  ZodNumber: Ee,
  ZodBigInt: Me,
  ZodBoolean: Ce,
  ZodDate: Be,
  ZodNull: $e,
  ZodOptional: G,
  ZodNullable: G,
  ZodDefault: Ve,
  ZodArray: Fe,
  ZodLiteral: Ge,
  ZodEnum: K,
  ZodNativeEnum: K,
  ZodTransformer: F,
  ZodEffects: F,
  ZodIntersection: Ke,
  ZodUnion: We,
  ZodDiscriminatedUnion: He,
  ZodNever: Qe,
  ZodBranded: Je,
  // TODO Transform the rest to schemas
  ZodUndefined: f,
  // TODO: `prefixItems` is allowed in OpenAPI 3.1 which can be used to create tuples
  ZodTuple: f,
  ZodMap: f,
  ZodFunction: f,
  ZodLazy: f,
  ZodPromise: f,
  ZodAny: f,
  ZodUnknown: f,
  ZodVoid: f
};
function u(e, t) {
  const { metaOpenApi: n = {} } = e, i = [
    e.isNullable && e.isNullable() ? { nullable: !0 } : {},
    ...Array.isArray(n) ? n : [n]
  ];
  try {
    const r = e._def.typeName;
    return r in W ? W[r]({
      zodRef: e,
      schemas: i,
      useOutput: t
    }) : f({ zodRef: e, schemas: i });
  } catch (r) {
    return console.error(r), f({ zodRef: e, schemas: i });
  }
}
v.generateSchema = u;
var S = {};
Object.defineProperty(S, "__esModule", { value: !0 });
S.extendZodWithOpenApi = void 0;
const Ye = v;
function Xe(e, t = !1) {
  !t && typeof e.ZodSchema.prototype.openapi < "u" || (e.ZodSchema.prototype.openapi = function(n) {
    return (0, Ye.extendApi)(this, n);
  });
}
S.extendZodWithOpenApi = Xe;
(function(e) {
  var t = O && O.__createBinding || (Object.create ? function(i, r, s, c) {
    c === void 0 && (c = s);
    var m = Object.getOwnPropertyDescriptor(r, s);
    (!m || ("get" in m ? !r.__esModule : m.writable || m.configurable)) && (m = { enumerable: !0, get: function() {
      return r[s];
    } }), Object.defineProperty(i, c, m);
  } : function(i, r, s, c) {
    c === void 0 && (c = s), i[c] = r[s];
  }), n = O && O.__exportStar || function(i, r) {
    for (var s in i) s !== "default" && !Object.prototype.hasOwnProperty.call(r, s) && t(r, i, s);
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), n(v, e), n(S, e);
})(X);
const { min: w, seq: P, conc: ze, maybe: z, oneOf: Dt } = h, Re = /^[A-Za-z0-9_-]+$/imsu, k = /(?:[_\p{Ll}\p{Lu}\p{Lt}\p{Lo}\p{Nl}][_.\p{L}\p{M}\p{Nd}\p{Nl}-]*)/imsu, R = new RegExp(`${k.source}[:]${k.source}`, "imsu"), ee = new RegExp(`${k.source}[:]`, "imsu"), et = /https?:\/\//, L = /[A-Za-z](?:[A-Za-z0-9-]*[A-Za-z0-9])?/, tt = P(L, w(0, P("[.]", L))), A = /%[0-9A-Fa-f]{2}/, te = /[A-Za-z0-9._~!$&'()*+,;=:@-]/, ae = w(1, A, te), at = P(w(0, P("/", ae)), z("/")), ne = ze(et, tt, at, z("#")), nt = /[A-Za-z0-9._~!$&'()*+,;=:-]/, ie = P(
  w(1, A, nt),
  w(0, A, te)
), re = P(/@/, w(1, /\d/)), it = ae, rt = {
  NCName: h.uaon(k),
  QName: h.uaon(R),
  AbbrevUri: h.uaon(ee),
  DomainLabel: h.uaon(L),
  PctEnc: h.uaon(A),
  PrefixUri: h.uaon(ne),
  DatasetItemId: h.uaon(ie),
  DatasetItemIx: h.uaon(re)
};
function At(e = "", t) {
  if (rt.AbbrevUri.test(e)) {
    const [n, i] = e.split(":");
    return n;
  }
  if (t === void 0)
    throw new Error(`invalid AbbrevUri: '${e}'`);
  return t;
}
const st = {
  // ISO 639-1 code: "English Name of Language"
  aa: "Afar",
  ab: "Abkhazian",
  ae: "Avestan",
  af: "Afrikaans",
  ak: "Akan",
  am: "Amharic",
  an: "Aragonese",
  ar: "Arabic",
  as: "Assamese",
  av: "Avaric",
  ay: "Aymara",
  az: "Azerbaijani",
  ba: "Bashkir",
  be: "Belarusian",
  bg: "Bulgarian",
  bi: "Bislama",
  bm: "Bambara",
  bn: "Bengali",
  bo: "Tibetan",
  br: "Breton",
  bs: "Bosnian",
  ca: "Catalan",
  //ca: "Valencian",
  ce: "Chechen",
  ch: "Chamorro",
  co: "Corsican",
  cr: "Cree",
  cs: "Czech",
  cu: "Church Slavic",
  //cu: "Church Slavonic",
  //cu: "Old Bulgarian",
  //cu: "Old Church Slavonic",
  //cu: "Old Slavonic",
  cv: "Chuvash",
  cy: "Welsh",
  da: "Danish",
  de: "German",
  //dv: "Dhivehi",
  //dv: "Divehi",
  dv: "Maldivian",
  dz: "Dzongkha",
  ee: "Ewe",
  el: "Greek, Modern (1453-)",
  en: "English",
  eo: "Esperanto",
  //es: "Castilian",
  es: "Spanish",
  et: "Estonian",
  eu: "Basque",
  fa: "Persian",
  ff: "Fulah",
  fi: "Finnish",
  fj: "Fijian",
  fo: "Faroese",
  fr: "French",
  fy: "Western Frisian",
  ga: "Irish",
  //gd: "Gaelic",
  gd: "Scottish Gaelic",
  gl: "Galician",
  gn: "Guarani",
  gu: "Gujarati",
  gv: "Manx",
  ha: "Hausa",
  he: "Hebrew",
  hi: "Hindi",
  ho: "Hiri Motu",
  hr: "Croatian",
  //ht: "Haitian Creole",
  ht: "Haitian",
  hu: "Hungarian",
  hy: "Armenian",
  hz: "Herero",
  ia: "Interlingua (International Auxiliary Language Association)",
  id: "Indonesian",
  ie: "Interlingue",
  //ie: "Occidental",
  ig: "Igbo",
  //ii: "Nuosu",
  ii: "Sichuan Yi",
  ik: "Inupiaq",
  io: "Ido",
  is: "Icelandic",
  it: "Italian",
  iu: "Inuktitut",
  ja: "Japanese",
  jv: "Javanese",
  ka: "Georgian",
  kg: "Kongo",
  //ki: "Gikuyu",
  ki: "Kikuyu",
  kj: "Kuanyama",
  //kj: "Kwanyama",
  kk: "Kazakh",
  kl: "Greenlandic",
  //kl: "Kalaallisut",
  km: "Central Khmer",
  kn: "Kannada",
  ko: "Korean",
  kr: "Kanuri",
  ks: "Kashmiri",
  ku: "Kurdish",
  kv: "Komi",
  kw: "Cornish",
  //ky: "Kirghiz",
  ky: "Kyrgyz",
  la: "Latin",
  //lb: "Letzeburgesch",
  lb: "Luxembourgish",
  lg: "Ganda",
  li: "Limburgan",
  //li: "Limburger",
  //li: "Limburgish",
  ln: "Lingala",
  lo: "Lao",
  lt: "Lithuanian",
  lu: "Luba-Katanga",
  lv: "Latvian",
  mg: "Malagasy",
  mh: "Marshallese",
  mi: "Maori",
  mk: "Macedonian",
  ml: "Malayalam",
  mn: "Mongolian",
  mr: "Marathi",
  ms: "Malay",
  mt: "Maltese",
  my: "Burmese",
  na: "Nauru",
  //nb: "Bokmål, Norwegian",
  nb: "Norwegian Bokmål",
  //nd: "Ndebele, North",
  nd: "North Ndebele",
  ne: "Nepali",
  ng: "Ndonga",
  nl: "Dutch",
  //nl: "Flemish",
  nn: "Norwegian Nynorsk",
  //nn: "Nynorsk, Norwegian",
  no: "Norwegian",
  //nr: "Ndebele, South",
  nr: "South Ndebele",
  //nv: "Navaho",
  nv: "Navajo",
  ny: "Chewa",
  //ny: "Chichewa",
  //ny: "Nyanja",
  oc: "Occitan (post 1500)",
  oj: "Ojibwa",
  om: "Oromo",
  or: "Oriya",
  os: "Ossetian",
  //os: "Ossetic",
  //pa: "Panjabi",
  pa: "Punjabi",
  pi: "Pali",
  pl: "Polish",
  ps: "Pashto",
  //ps: "Pushto",
  pt: "Portuguese",
  qu: "Quechua",
  rm: "Romansh",
  rn: "Rundi",
  //ro: "Moldavian",
  //ro: "Moldovan",
  ro: "Romanian",
  ru: "Russian",
  rw: "Kinyarwanda",
  sa: "Sanskrit",
  sc: "Sardinian",
  sd: "Sindhi",
  se: "Northern Sami",
  sg: "Sango",
  //si: "Sinhala",
  si: "Sinhalese",
  sk: "Slovak",
  sl: "Slovenian",
  sm: "Samoan",
  sn: "Shona",
  so: "Somali",
  sq: "Albanian",
  sr: "Serbian",
  ss: "Swati",
  st: "Sotho, Southern",
  su: "Sundanese",
  sv: "Swedish",
  sw: "Swahili",
  ta: "Tamil",
  te: "Telugu",
  tg: "Tajik",
  th: "Thai",
  ti: "Tigrinya",
  tk: "Turkmen",
  tl: "Tagalog",
  tn: "Tswana",
  to: "Tonga (Tonga Islands)",
  tr: "Turkish",
  ts: "Tsonga",
  tt: "Tatar",
  tw: "Twi",
  ty: "Tahitian",
  ug: "Uighur",
  //ug: "Uyghur",
  uk: "Ukrainian",
  ur: "Urdu",
  uz: "Uzbek",
  ve: "Venda",
  vi: "Vietnamese",
  vo: "Volapük",
  wa: "Walloon",
  wo: "Wolof",
  xh: "Xhosa",
  yi: "Yiddish",
  yo: "Yoruba",
  //za: "Chuang",
  za: "Zhuang",
  zh: "Chinese",
  zu: "Zulu"
};
X.extendZodWithOpenApi(a);
const ot = xe();
function j(e, t) {
  return a.string().refine((n) => h.uaon(e).test(String(n)), {
    message: t
  });
}
const se = a.array(a.number()).min(2).max(2), pt = a.number(), g = a.string().regex(Re), oe = a.object({
  id: a.string()
}).and(a.record(a.string(), a.unknown())), pe = a.array(
  se.nullable(),
  pt.nullable()
), T = j(k, "Invalid NCName format"), q = j(R, "Invalid QName format"), ct = j(
  ie,
  "Invalid DatasetItemId format"
), lt = j(
  re,
  "Invalid DatasetItemIx format"
), D = a.number().int().nonnegative(), ce = j(
  it,
  "Invalid DatasetItemIdOrIx format"
), le = j(ne, "Invalid prefix URI format"), de = a.record(le, T), ue = j(ee, "Invalid abbreviated URI format"), [dt, ...ut] = Object.keys(st), M = a.enum([dt, ...ut]), me = a.object({
  title: a.string(),
  terms: a.record(T, a.string())
}), fe = a.record(M, me), he = a.record(T, fe), ye = a.object({ preset: a.literal(!0), to: a.unknown() }), C = a.object({
  from: a.string().optional(),
  titleUri: q.optional(),
  filter: a.union([ye, a.boolean()]).optional(),
  search: a.boolean().optional()
}), be = a.object({
  type: a.literal("value"),
  as: a.union([a.literal("string"), a.literal("boolean"), a.literal("number")]).optional(),
  strict: a.boolean().optional(),
  nullable: a.boolean().optional()
}), ge = a.object({
  type: a.literal("vocab"),
  uri: ue,
  /**
   * Indicates whether the options should be sorted in filter dropdowns.
   * If set to false, no sorting will occur.
   * Sorting is set to 'asc' by default
   * If set to 'asc' or 'desc', the options will be sorted accordingly.
   */
  sorted: a.union([a.boolean(), a.literal("asc"), a.literal("desc")]).optional()
}), mt = a.union([be, ge]), ft = a.object({
  type: a.literal("multi"),
  of: mt
}), B = C.merge(be), ve = C.merge(ge), je = C.merge(ft), Ie = a.discriminatedUnion("type", [
  B,
  ve,
  je
]), we = a.object({
  // the 'id' itemProp is required, as a non-filterable ValuePropSpec
  id: B.extend({
    filter: a.literal(!1).optional()
  })
}).and(a.record(a.string(), Ie)), Z = a.object({
  itemProp: a.string(),
  valueStyle: a.union([a.literal("text"), a.literal("address"), a.literal("hyperlink")]).default("text"),
  showBullets: a.boolean().default(!1),
  singleColumnLimit: a.number().optional(),
  showLabel: a.boolean().default(!1),
  hyperlinkBaseUri: a.string().default(""),
  displayText: a.string().optional(),
  analyticOnClick: a.boolean().default(!1)
}), ht = a.record(a.string(), a.number()), Pe = a.object({
  prefixes: de,
  vocabs: he,
  itemProps: we,
  languages: a.array(M).nonempty(),
  ui: a.object({
    directory_panel_field: a.string(),
    title: a.string().optional(),
    dataLastUpdated: a.string().datetime().optional(),
    show_map_key: a.boolean().optional(),
    customMarkers: a.object({
      marker_property_name: a.string(),
      markerIcons: a.array(a.string()),
      termsToIconIndex: a.intersection(
        a.object({ default: a.number() }),
        a.record(a.number())
      )
    }).optional(),
    map: a.object({
      mapBounds: a.tuple([
        a.tuple([a.number(), a.number()]),
        a.tuple([a.number(), a.number()])
      ]).optional()
    }).optional(),
    logo: a.object({
      largeLogo: a.string().optional(),
      smallLogo: a.string().optional(),
      altText: a.string().optional(),
      smallScreenPosition: a.object({
        top: a.string().optional(),
        left: a.string().optional()
      }).optional(),
      largeScreenPosition: a.object({
        bottom: a.string().optional(),
        right: a.string().optional()
      }).optional()
    }).optional()
  }),
  popup: a.object({
    titleProp: a.string(),
    leftPaneWidth: a.string().default("70%"),
    leftPane: a.array(Z),
    topRightPane: a.array(Z),
    bottomRightPane: a.array(Z)
  })
}), ke = a.object({
  name: a.string(),
  buildTime: a.string().datetime({ offset: !1 }),
  version: a.array(a.number()).min(1).readonly(),
  commitDesc: a.string(),
  nodeEnv: a.string()
}), d = a.object({ message: a.string() }).passthrough(), yt = {
  AbbrevUri: ue,
  Location: se,
  ConfigData: Pe,
  DatasetId: g,
  DatasetItemId: ct,
  DatasetItemIdOrIx: ce,
  DatasetItemIx: lt,
  DatasetItemIxRaw: D,
  DatasetItem: oe,
  DatasetLocations: pe,
  FilterSpec: ye,
  I18nVocabDef: fe,
  Iso639Set1Code: M,
  MultiPropSpec: je,
  NCName: T,
  PrefixUri: le,
  PrefixIndex: de,
  PropSpec: Ie,
  PropSpecs: we,
  QName: q,
  ValuePropSpec: B,
  BuildInfo: ke,
  VocabDef: me,
  VocabIndex: he,
  VocabPropSpec: ve,
  ErrorInfo: d
}, qt = ot.router({
  getDatasetLocations: {
    method: "GET",
    path: "/dataset/:datasetId/locations",
    summary: "obtains a dataset's locations",
    description: "Obtains all the locations for a dataset by the dataset ID, which by passing in the appropriate options, might be in different formats",
    pathParams: a.object({
      datasetId: g.openapi({
        description: "uniquely specifies the dataset wanted"
      })
    }),
    responses: {
      200: pe.openapi({
        description: "the dataset matching the supplied ID"
      }),
      400: d.openapi({
        description: "bad input parameter"
      }),
      404: d.openapi({
        description: "no such dataset"
      })
    }
  },
  searchDataset: {
    method: "GET",
    path: "/dataset/:datasetId/search",
    summary: "obtains a list of dataset entries satisfying the search criteria supplied",
    description: "Obtains an array of dataset item indexes, which match the search criteria supplied",
    query: a.object({
      text: a.string().optional().openapi({
        description: "a text fragment to match"
      }),
      // Promote singular parameters to arrays (so that a single filter is possible!),
      // see https://github.com/ts-rest/ts-rest/issues/290#issuecomment-1658983510
      filter: a.array(q).or(q.transform((e) => [e])).optional().openapi({
        description: "uniquely specifies the taxonomy filter items wanted"
      }),
      returnProps: a.array(a.string()).optional().openapi({
        description: "The props to return as an array of item objects. If not specified, only an flattened array of indexes is returned."
      }),
      page: a.coerce.number().int().nonnegative().optional().openapi({
        description: "The page number to return. If not specified, all items are returned."
      }),
      pageSize: a.coerce.number().int().positive().optional().openapi({
        description: "The number of items per page. If not specified, all items are returned."
      })
    }),
    pathParams: a.object({
      datasetId: g.openapi({
        description: "uniquely specifies the dataset wanted"
      })
    }),
    responses: {
      200: a.union([
        a.array(D),
        a.array(
          a.record(a.string(), a.unknown()).and(a.object({ index: D }))
        )
      ]).openapi({
        description: "the dataset item indexes matching the supplied criteria"
      }),
      400: d.openapi({
        description: "bad input parameter"
      }),
      404: d.openapi({
        description: "no such dataset"
      })
    }
  },
  getDatasetItem: {
    method: "GET",
    path: "/dataset/:datasetId/item/:datasetItemIdOrIx",
    summary: "obtains a dataset item by its unique ID",
    description: "Obtains a single dataset item by its ID or its index, and the dataset's ID.",
    pathParams: a.object({
      datasetId: g.openapi({
        description: "uniquely specifies the dataset wanted"
      }),
      datasetItemIdOrIx: ce.openapi({
        description: "Uniquely specifies the dataset item wanted within the dataset. This param must be base64 encoded. The decoded param should start with an @ to indicate an index, otherwise it is assumed to be an id"
      })
    }),
    query: a.object({
      returnProps: a.array(a.string()).optional().openapi({
        description: "The props to return. If not specified, all props are returned. Note that the item's ID and index are always returned."
      })
    }),
    responses: {
      200: oe.and(a.object({ index: D })).openapi({
        description: "the dataset item matching the supplied ID or index"
      }),
      400: d.openapi({
        description: "bad input parameter"
      }),
      404: d.openapi({
        description: "no such dataset or dataset item"
      })
    }
  },
  getTotals: {
    method: "GET",
    path: "/dataset/:datasetId/totals",
    summary: "get the total number of results under each item in the directory",
    description: "Gets the total number of results under each item in the directory.",
    pathParams: a.object({
      datasetId: g.openapi({
        description: "uniquely specifies the dataset wanted"
      })
    }),
    responses: {
      200: ht.openapi({
        description: "the total result numbers for a map"
      }),
      400: d.openapi({
        description: "bad input parameter"
      }),
      404: d.openapi({
        description: "no such dataset"
      })
    }
  },
  getConfig: {
    method: "GET",
    path: "/dataset/:datasetId/config",
    summary: "obtain various configured parameters for a dataset",
    description: "Obtains configured parameters for a datset, which amongst other things, include default values for various options, and definitions of vocabulary terms with their localised labels, that are used to interpret identifers in the data and/or elsewhere.",
    pathParams: a.object({
      datasetId: g.openapi({
        description: "uniquely specifies the dataset wanted"
      })
    }),
    responses: {
      200: Pe.openapi({
        description: "various configured parameters for a map"
      }),
      400: d.openapi({
        description: "bad input parameter"
      }),
      404: d.openapi({
        description: "no such dataset"
      })
    }
  },
  getAbout: {
    method: "GET",
    path: "/dataset/:datasetId/about",
    summary: "obtain the About text for a dataset",
    description: "Obtains information about the datset, in markdown format so it can be easily rendered on a front-end application.",
    pathParams: a.object({
      datasetId: g.openapi({
        description: "uniquely specifies the dataset wanted"
      })
    }),
    responses: {
      200: a.string().openapi({
        description: "About text in markdown format"
      }),
      400: d.openapi({
        description: "bad input parameter"
      }),
      404: d.openapi({
        description: "no such dataset"
      })
    }
  },
  getVersion: {
    method: "GET",
    path: "/version",
    summary: "obtains Mykomap server version information",
    description: "Obtains version information about the backend Mykomap server, in the form of a JSON object",
    responses: {
      200: ke.openapi({
        description: "information about the current Mykomap server build"
      })
    }
  },
  listDatasets: {
    method: "GET",
    path: "/datasets",
    summary: "lists the datasets available on this server",
    description: "Returns an array of the datasets available on this server, each entry carrying the dataset ID and a human-readable label (taken from config.ui.logo.altText, falling back to the ID).",
    responses: {
      200: a.array(
        a.object({
          id: g,
          label: a.string()
        })
      ).openapi({
        description: "the list of available datasets"
      })
    }
  }
}), H = (e) => e.reduce((t, n) => vt(t, n), void 0), Q = (e) => e.reduce((t, n) => gt(t, n), void 0), Nt = (e) => typeof e == "boolean";
function bt(e) {
  switch (e.trim().toLowerCase()) {
    case "true":
    case "t":
    case "yes":
    case "y":
    case "1":
      return !0;
    case "false":
    case "f":
    case "no":
    case "n":
    case "0":
      return !1;
    default:
      return;
  }
}
function St(e, t = !1) {
  if (e == null) return t;
  switch (typeof e) {
    case "string":
      return bt(e) ?? t;
    case "bigint":
    case "number":
      return e == 0;
    case "boolean":
      return e;
    case "object":
      return t;
    case "symbol":
    case "undefined":
    case "function":
    default:
      return t;
  }
}
const Tt = (e) => typeof e == "string", Oe = (e, t = "") => typeof e == "string" ? e : t, J = (e, t = 0) => isNaN(e) ? t : e, Zt = (e) => typeof e == "number", Et = (e) => typeof e == "number" && !isNaN(e);
function _(e, t = 0) {
  switch (typeof e) {
    case "number":
      return J(e, t);
    case "string":
      return J(Number.parseFloat(e), t);
    default:
      return t;
  }
}
function N(e) {
  return !(!(e instanceof Array) || e.length < 2 || e.length !== 2 || typeof e[0] != "number" || isNaN(e[0]) || typeof e[1] != "number" || isNaN(e[1]));
}
function Y(e, t) {
  if (e instanceof Array) {
    if (e.length == 2 && typeof e[0] == "number" && typeof e[1] == "number")
      return e;
    if (e.length < 2) return t;
    const n = _(e[0], null), i = _(e[1], null);
    return typeof n == "number" && typeof i == "number" ? [n, i] : t;
  }
  if (e instanceof Object) {
    if ("0" in e && "1" in e) {
      const n = _(e[0], null), i = _(e[1], null);
      if (typeof n == "number" && typeof i == "number") return [n, i];
    }
    return t;
  }
  return t;
}
function Lt(e) {
  return !(!(e instanceof Array) || e.length < 2 || e.length !== 2 || !N(e[0]) || !N(e[1]));
}
function Ut(e) {
  return Number.isFinite(e[0][0]) && Number.isFinite(e[0][1]) && Number.isFinite(e[1][0]) && Number.isFinite(e[1][1]);
}
function Mt(e, t) {
  if (e instanceof Array && e.length >= 2) {
    if (N(e[0]) && N(e[1]))
      return e.length === 2 ? e : [e[0], e[1]];
    const n = Y(e[0], null), i = Y(e[0], null);
    if (n && i) return [n, i];
  }
  return t;
}
function Ct(e, t) {
  return e ? t ? [
    [
      Math.min(e[0][0], e[1][0], t[0][0], t[1][0]),
      Math.min(e[0][1], e[1][1], t[0][1], t[1][1])
    ],
    [
      Math.max(e[0][0], e[1][0], t[0][0], t[1][0]),
      Math.max(e[0][1], e[1][1], t[0][1], t[1][1])
    ]
  ] : e : t || void 0;
}
function gt(e, t) {
  return e == null ? t ?? void 0 : t == null || e < t ? e : t;
}
function vt(e, t) {
  return e == null ? t ?? void 0 : t == null || e > t ? e : t;
}
function Bt(e, t) {
  let n = Q(e);
  if (n === void 0) return;
  let i = Q(t);
  if (i === void 0) return;
  let r = H(e);
  if (r === void 0) return;
  let s = H(t);
  if (s !== void 0)
    return [
      [n, i],
      [r, s]
    ];
}
function $t(e) {
  return e instanceof Array ? e : e == null ? [] : [e];
}
const Vt = (e) => e !== void 0, jt = (e) => e != null;
function Ft(e) {
  return e ? e.filter(jt) : [];
}
function Gt(e, t) {
  if (!e) throw new Error(t);
}
function Kt(e, t) {
  const n = /* @__PURE__ */ new Set();
  return e.forEach((i) => {
    t(i) && n.add(i);
  }), n;
}
function Wt(e, t) {
  let n = "";
  const i = [];
  let r = !1;
  for (var s of e) {
    if (r) {
      n += s, r = !1;
      continue;
    }
    switch (s) {
      case t.delim:
        i.push(n), n = "";
        break;
      case t.escape:
        r = !0;
        break;
      default:
        n += s;
    }
  }
  return i.push(n), i;
}
function It(e) {
  return e.name.replace(/[\/\\\s]+/g, "") + "@" + e.version.join(".");
}
function wt(e) {
  return e.commitDesc.split("-").slice(2).join("-");
}
function Ht(e) {
  Object.keys(e).forEach((t) => delete e[t]);
}
class Qt {
  /** Normalises a text string into an indexable form.
   *
   * Performs these steps:
   * - Lower-cases it
   * - Eliminates non word-breaking punctuation (`\`'`)
   * - Converts all other punctuation to space characters.
   * - Deduplicates whitespace
   * - Trims whitespace from front and back of the string.
   */
  static normalise(t) {
    return t.toLowerCase().replace(/['`]/, "").replace(/[^\w ]+/g, " ").replace(/\s+/g, " ").trim();
  }
}
class Jt {
  _vocabs;
  /** Constructor.
   *
   * @param vocabs - all the vocab definitions we will require to create VocabPropDefs.
   * @param checkLangs - if given, check that the vocabs include translations for these languages.
   */
  constructor(t, n) {
    if (this._vocabs = yt.VocabIndex.parse(t), n) {
      const i = [];
      for (const r in this._vocabs) {
        const s = this._vocabs[r];
        n.every((c) => c in s) || i.push(r);
      }
      if (i.length)
        throw new Error(
          `PropDefServices initialised with these Vocabs which are incompatible with the target languages '${n}': ${i}`
        );
    }
  }
  /** Looks up an interationalised vocab given its URI */
  i18nVocabDef(t) {
    const n = t.replace(/:$/, ""), i = this._vocabs[n];
    if (i == null) throw new Error(`unknown vocab URI: '${t}'`);
    return i;
  }
  mkPropDef(t) {
    switch (t.type) {
      case "value":
        return new Pt(t);
      case "vocab":
        return new _e(t, this.i18nVocabDef(t.uri));
      case "multi":
        const n = this.mkPropDef(t.of);
        return new kt({ ...t, of: n });
    }
  }
  /** Make a Record of indexed PropDefs from a Dictionary of ProfSpecs
   *
   *
   * @param specs - a Dictionary of PropSpecs.
   * @returns A record of PropDefs, indexed by the same keys as the
   * relevant PropSpec.
   *
   * A Dictionary may have undefined elements; a Record, by definition, doesn't.
   * This function should honour that, and guarantee none.
   */
  mkPropDefs(t) {
    const n = {};
    for (const i in t) {
      const r = t[i];
      r != null && (n[i] = this.mkPropDef(r));
    }
    return n;
  }
}
class $ {
  from;
  titleUri;
  filter;
  search;
  /** Constructor.
   *
   * @param init - the specification to use
   */
  constructor(t) {
    this.from = t.from, this.titleUri = t.titleUri, this.filter = t.filter ?? !1, this.search = !!t.search;
  }
  /** @return true if and only if a filter should be created for this PropDef */
  isFiltered() {
    return !!this.filter;
  }
}
class Pt extends $ {
  /** The type specifier */
  type = "value";
  /** Conversion hints */
  as;
  nullable;
  strict;
  /** Constructor
   * @param init - the specification for the ValuePropDef
   */
  constructor(t) {
    super(t), this.as = t.as, this.nullable = t.nullable === !0, this.strict = t.strict === !0;
  }
  /**
   * This is always undefined for instances of this class, as they don't have URIs.
   */
  get uri() {
  }
  textForValue(t) {
    return t === void 0 ? void 0 : Oe(t);
  }
}
class _e extends $ {
  /** Constructor
   * @param init - the specification for the VocabPropDef
   * @param i18nVocab - the internationalised vocab definitions to use
   */
  constructor(t, n) {
    super(t), this.i18nVocab = n, this.uri = t.uri;
  }
  /** The type specifier */
  type = "vocab";
  /** The (abbreviated) vocabulary URI */
  uri;
  /** Looks up a localised vocab, given a language code */
  localisedVocabDef(t) {
    const n = this.i18nVocab[t];
    if (n == null)
      throw new Error(
        `no terms defined for language code '${t}' in vocab '${this.uri}'`
      );
    return n;
  }
  textForValue(t, n) {
    if (n === void 0)
      throw new Error(`no language code provided for vocab '${this.uri}'`);
    return typeof t == "string" ? this.localisedVocabDef(n).terms[t] : "";
  }
}
class kt extends $ {
  type = "multi";
  of;
  /**
   * This indicates the vocab URI in use if pertinent. It is undefined otherwise
   */
  get uri() {
    if (this.of.type === "vocab") return this.of.uri;
  }
  /**
   * This indicates the internationalised vocab definition in use if it contains vocab values. It
   * is undefined otherwise.
   */
  i18nVocab;
  /** Constructor
   *
   * @param init - the specification for this MultiPropSpec. Note, we insist on
   * the of: parameter to be concrete so we can delegate getTextForProperty
   * calls to it.
   */
  constructor(t) {
    super(t), this.of = t.of, t.of instanceof _e && (this.i18nVocab = t.of.i18nVocab);
  }
  textForValue(t, n) {
    return t instanceof Array ? t.map((i) => Oe(this.of.textForValue(i, n))) : [];
  }
}
class Yt {
  /** A stub method for executing commands.
   *
   * Typically this will be a reference to `spawnSync`, provided by NodeJS. But
   * since we want this class to be defined without NodeJS dependencies, so it
   * can be included everywhere and only used in vite.config.ts, it needs to be
   * provided via the constructor.
   */
  exec;
  /** The name of the software component */
  name;
  /* The time it was built. Should be a UTC ISO string as returned by Date.toISOString() */
  buildTime;
  /** The commit descriptor. Should be a string as returned by gitDescribe() */
  commitDesc;
  /** The tagged version. Should be a numeric array as returned by
   * gitVersion() */
  version;
  /** The build environment. A string, typically 'development' or 'production',
   * but may be an empty string if nothing is set */
  nodeEnv;
  /** Convenience method to get a sentryRelease string for this instance */
  get sentryRelease() {
    return It(this);
  }
  /** Convenience method to get a sentryDist string for this instance */
  get sentryDist() {
    return wt(this);
  }
  /** Obtain a numeric version array from git tags.
   *
   * Calls `git-describe` to search backwards in the git history for the last
   * "versiony" tag. Meaning, a match for any tag beginning with a `v`, followed
   * by one or more unsigned decimal numbers delimited by single periods.
   *
   * It then attempts to parse that by splitting on non-numeric characters and
   * converting to a list of positive integers.
   *
   * Assumes the code is running in a git working directory!
   *
   * If we can't find any matching tags, we return an array with a single zero:
   * `[0]`
   *
   */
  gitVersion() {
    const t = this.exec("git", [
      "describe",
      "--tags",
      "--match=v[0-9]*",
      "--exclude=v*[^0-9.]*",
      "--exclude=*..*",
      "--exclude=*.",
      "--abbrev=0"
    ]).trim();
    return typeof t == "string" ? t.substring(1).split(".").map(Number) : [0];
  }
  /** Get the git-describe commit information.
   *
   * This provides version information for a more discerning audience. It uses
   * `git-describe` to search back through the history for any tag at all.
   *
   * The result will be a string with the format: "[<TAG>-<COUNT>-]<COMMIT-ID>[-dirty]"
   * - Items in square brackets may be absent.
   * - TAG is the last "versiony" tag found in the commit history, if there is one,
   *   otherwise this and the next dash delimiter are omitted.
   * - COUNT is the number of commts from the tag (or the first commit if none) to the current commit.
   * - COMMIT-ID is the abbreviated SHA1 commit ID.
   * - A "dirty" suffix indicates a build in a dirty working directory.
   * - Note that TAG may contain any character a tag can, including a hyphen.
   * - Therefore it might not be a version string.
   *
   * (See the docs for `gitVersion` for the meaning of "versiony".)
   */
  gitDescribe() {
    return this.exec("git", [
      "describe",
      "--tags",
      "--match=v[0-9]*",
      "--exclude=v*[^0-9.]*",
      "--always",
      "--long",
      "--dirty"
    ]).trim();
  }
  updatePackageJson() {
    const { version: t, sentryRelease: n } = this;
    this.exec("npm", [
      "pkg",
      "set",
      "version=" + t.join("."),
      "config.sentry.release=" + n
    ]);
  }
  /** Constuctor.
   *
   * The `name` parameter is required, all others have defaults inferred from `git-describe`
   */
  constructor(t) {
    this.exec = t.exec, this.name = t.name, this.buildTime = t?.buildTime ?? (/* @__PURE__ */ new Date()).toISOString(), this.commitDesc = t?.commitDesc ?? this.gitDescribe(), this.version = t?.version ?? this.gitVersion(), this.nodeEnv = t?.nodeEnv ?? process.env.NODE_ENV ?? "", Object.defineProperty(this, "exec", { enumerable: !1 });
  }
}
export {
  ee as AbbrevUri,
  $ as CommonPropDef,
  ie as DatasetItemId,
  it as DatasetItemIdOrIx,
  re as DatasetItemIx,
  st as Iso639Set1Codes,
  kt as MultiPropDef,
  k as NCName,
  ne as PrefixUri,
  Jt as PropDefsFactory,
  R as QName,
  Yt as ReadonlyBuildInfo,
  h as RxUtils,
  Qt as TextSearch,
  rt as UAON,
  Re as UrlSafeBase64,
  Pt as ValuePropDef,
  _e as VocabPropDef,
  H as arrayMax,
  Q as arrayMin,
  Bt as arrays2Box2d,
  Gt as assert,
  St as boolify,
  Ct as box2dUnion,
  Ht as clear,
  Ft as compactArray,
  qt as contract,
  Kt as filterSet,
  vt as highest,
  Nt as isBool,
  Lt as isBox2d,
  Ut as isFiniteBox2d,
  Zt as isNumber,
  N as isPoint2d,
  Tt as isString,
  gt as lowest,
  jt as notNullish,
  Vt as notUndefined,
  _ as numberify,
  At as parseAbbrevUri,
  $t as promoteToArray,
  yt as schemas,
  wt as sentryDist,
  It as sentryRelease,
  xt as specification,
  Wt as splitField,
  Oe as stringify,
  bt as textToBool,
  Mt as toBox2d,
  Y as toPoint2d,
  J as toYesANumber,
  Et as yesANumber
};
